<!-- 实操演练 -->
<template>
  <div class="page-layer">
    <!-- 模式内容 -->
    <div class="exam-wrap">
      <!-- <div style="color: #fff;">{{ sceneType }}</div> -->
      <!-- 1、练习 -->
      <div v-show="active === 1" class="mode-view">
        <template v-if="type == '1'">
          <div class="block" v-if="sceneType == '智能客服'">
            <div class="block-title">智能客服</div>
            <ul :class="{ 'notData': !practice.tableData1.length }" v-loading="practice.loading">
              <li :class="['znkf', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData1" :key="index" @click="openCase(item, '智能客服')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>
          <div class="block" v-if="sceneType == '岗位训练'">
            <!-- <div class="block-title">训练智能体</div> -->
            <div class="block-title">岗位训练</div>
            <ul :class="{ 'notData': !practice.tableData2.length }" v-loading="practice.loading">
              <li :class="['znt', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData2" :key="index" @click="openCase(item, '训练智能体')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>
          <div class="block" v-if="sceneType == '投资分析与策略制定'">
            <!-- <div class="block-title">投研报告智能体</div> -->
            <div class="block-title">投资分析与策略制定</div>
            <ul :class="{ 'notData': !practice.tableData3.length }" v-loading="practice.loading">
              <li :class="['tybg', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData3" :key="index" @click="openCase(item, '投研报告智能体')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>

          <div class="block" v-if="sceneType == '商务数据分析智能体'">
            <div class="block-title">商务数据分析智能体</div>
            <ul :class="{ 'notData': !practice.tableData5.length }" v-loading="practice.loading">
              <li :class="['swsjbg', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData5" :key="index" @click="openCase(item, '商务数据分析智能体')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>

          <div class="block" v-if="sceneType == '金融风险管理'">
            <!-- <div class="block-title">贷款额度预测智能体</div> -->
            <div class="block-title">金融风险管理</div>
            <ul :class="{ 'notData': !practice.tableData6.length }" v-loading="practice.loading">
              <li :class="['tybg', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData6" :key="index" @click="openCase(item, '金融风险管理')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>

          <div class="block" v-if="sceneType == '金融反欺诈'">
            <!-- <div class="block-title">金融反欺诈预测</div> -->
            <div class="block-title">金融反欺诈</div>
            <ul :class="{ 'notData': !practice.tableData7.length }" v-loading="practice.loading">
              <li :class="['fqzbg', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData7" :key="index" @click="openCase(item, '金融反欺诈')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>

          <div class="block" v-if="sceneType == '智能保险推荐'">
            <div class="block-title">智能保险推荐</div>
            <ul :class="{ 'notData': !practice.tableData8.length }" v-loading="practice.loading">
              <li :class="['fqzbg', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData8" :key="index" @click="openCase(item, '智能保险推荐')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>

          <div class="block" v-if="sceneType == '金融合规与监管'">
            <div class="block-title">金融合规与监管</div>
            <ul :class="{ 'notData': !practice.tableData9.length }" v-loading="practice.loading">
              <li :class="['fqzbg', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData9" :key="index" @click="openCase(item, '金融合规与监管')">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>

        </template>

        <template v-else>
          <div class="block">
            <div class="block-title">工作流</div>
            <ul :class="{ 'notData': !practice.tableData4.length }" v-loading="practice.loading">
              <li :class="['gzl', `icon${index % 5 + 1}`, { 'not': item.state == 2, 'afoot': item.state == 1, 'end': item.state == 3 }]"
                  v-for="(item, index) in practice.tableData4" :key="index" @click="openCase(item)">
                <div class="title-inner">{{ item.name }}</div>
              </li>
            </ul>
          </div>
        </template>

        <!-- 练习 - 记录 -->
        <div class="block">
          <div class="block-title">练习记录</div>
          <div class="style-table-wrap">
            <el-table :data="record.tableData" border style="width: 100%" :cell-class-name="cellClassName">
              <div slot="empty" :class="{ 'empty': !record.tableData.length }"></div>
              <el-table-column prop="submissionTime" label="练习时间" align="center">
                <div slot="header" class="table-header-item">
                  <span>练习时间</span>
                </div>
                <template slot-scope="scope">
                  {{ scope.row.submissionTime }}
                </template>
              </el-table-column>
              <el-table-column prop="caseName" label="练习案例" align="center">
                <div slot="header" class="table-header-item">
                  <span>练习案例</span>
                </div>
                <template slot-scope="scope">
                  {{ scope.row.caseName }}
                </template>
              </el-table-column>
              <el-table-column prop="testName" label="得分" align="center">
                <div slot="header" class="table-header-item">
                  <span>得分</span>
                </div>
                <template slot-scope="scope">
                  得分：{{ scope.row.totalScore }} /总分：{{ scope.row.maxScore }}分
                </template>
              </el-table-column>
              <el-table-column prop="testName" label="解析" align="center">
                <div slot="header" class="table-header-item">
                  <span>解析</span>
                </div>
                <template slot-scope="scope">
                  <div style="cursor: pointer;color: #4568F7;" @click="handleAnalysisOpen(scope.row)">查看</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-wrap">
            <el-pagination @current-change="getRecordData" background layout="total,prev, pager, next"
                           :current-page.sync="record.param.pageIndex" :page-size="record.param.pageSize"
                           :total="record.totalNum"></el-pagination>
          </div>
        </div>
      </div>

    </div>

    <!-- 弹框：练习解析 -->
    <el-dialog class="caseAnalysis-dialog custom-dialog" title="案例操作解析" center
               :visible.sync="caseAnalysis.dialogVisible" width="80%" append-to-body>
      <div class="style-table-wrap" style="height: 6rem;overflow: auto;padding: 0;margin: 0;">
        <el-table :data="caseAnalysis.tableData" border style="width: 100%" v-loading="caseAnalysis.loading"
                  :span-method="arraySpanMethod">
          <div slot="empty" :class="{ 'empty': !caseAnalysis.tableData.length }"></div>
          <el-table-column prop="workflowName" label="工作流" align="center">
            <template slot-scope="scope">
              {{ scope.row.workflowName }}
            </template>
          </el-table-column>
          <el-table-column prop="isCorrect" label="是否正确" align="center">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.isCorrect ? 'green' : 'red' }">{{ scope.row.isCorrect ? '正确' : '错误'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="分值" align="center">
            <template slot-scope="scope">
              {{ scope.row.score }}
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="配置项" align="center">
            <template slot-scope="scope">
              {{ scope.row.itemName }}
            </template>
          </el-table-column>
          <el-table-column prop="description" label="结果" align="center" width="500">
            <template slot-scope="scope">
              <p v-html="scope.row.description"></p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import apiExamine from '@/api/apiExamine.js'
import apiUser from "@/api/user"
import { GetLableItems } from "@/api/flow.api"

export default {
  data () {
    return {
      active: 1, // 1：练习 2：考核
      // 1：进行中 2：未开始 3：已完成 4：提前交卷(为了判断考核模式能不能看考核成绩)
      caseStateName: {
        1: '进行中',
        2: '未开始',
        3: '已完成',
        4: '已提前交卷'
      },
      // 练习列表
      practice: {
        loading: false,
        tableData1: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        tableData5: [],
        tableData6: [],
        tableData7: [],
        tableData8: [],
        tableData9: [],
      },
      // 考核列表
      exam: {
        loading: false,
        tableData1: [],
        tableData2: []
      },
      // 练习记录
      record: {
        param: {
          pageIndex: 1,
          pageSize: 5
        },
        totalNum: 0,
        tableData: []
      },
      // 弹框：练习解析
      caseAnalysis: {
        dialogVisible: false,
        tableData: [],
        tableData2: [],
        param: {
          pageIndex: 1,
          pageSize: 100
        },
        totalNum: 0
      },
      sceneType: sessionStorage.getItem('sceneType')
    }
  },
  computed: {
    type () {
      let casetype = sessionStorage.getItem('casetype')
      return casetype
    }
  },
  watch: {
    active: {
      handler (newVal) {
        if (newVal === 1) {
          this.getPracticeData()
          // this.getRecordData()
        } else {
          this.getExamData()
        }
      },
      immediate: true
    }
  },
  created () {
    this.init()
    this.getFlowID()
    // this.getRecordData()
  },
  mounted () {
    this.getRecordData()
  },
  beforeDestroy () {

  },
  methods: {
    init () {
      this.loading = this.$loading({
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      apiUser.GetCaseList({
        mode: this.type = this.type == 1 ? 2 : 1,
      }
      ).then((res) => {
        this.loading.close()
        if (this.type == 1) {
          // this.practice.tableData1 = res.data[0].cases || []
          if (res.data.length > 0) {
            res.data.forEach(item => {
              if (item.scenarioType == 0) {
                this.practice.tableData1 = item.cases || []
              } else if (item.scenarioType == 1) {
                this.practice.tableData2 = item.cases || []
              } else if (item.scenarioType == 2) {
                this.practice.tableData3 = item.cases || []
              } else if (item.scenarioType == 3) {
                this.practice.tableData4 = item.cases || []
              } else if (item.scenarioType == 4) {
                this.practice.tableData5 = item.cases || []
              } else if (item.scenarioType == 5) {
                this.practice.tableData6 = item.cases || []
              } else if (item.scenarioType == 6) {
                this.practice.tableData7 = item.cases || []
              } else if (item.scenarioType == 7) {
                this.practice.tableData8 = item.cases || []
              } else if (item.scenarioType == 8) {
                this.practice.tableData9 = item.cases || []
              }
            })
          }
        } else {
          this.practice.tableData4 = res.data || []
        }
      });
    },

    // 获取智能体流ID
    getFlowID () {
      GetLableItems().then(res => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].lableName == '客服工作流') {
              window.CJTY_AIwenda_token = res.data[i].key
            }
            if (res.data[i].lableName == '问答工作流') {
              window.CJTY_AItiwen_token = res.data[i].key
            }
            if (res.data[i].lableName == '计分工作流') {
              window.CJTY_AIjifen_token = res.data[i].key
            }
          }
          sessionStorage.setItem('znkf_key', window.CJTY_AIwenda_token)
          sessionStorage.setItem('xlznt_tw_key', window.CJTY_AItiwen_token)
          sessionStorage.setItem('xlznt_jf_key', window.CJTY_AIjifen_token)
        }
      })
    },

    cellClassName () {
      return 'warning-cell';
    },

    // 获取实训列表数据
    getTableData (callback) {
      // apiExamine.GetExamineList({
      //   cmode: this.active, // 实训模式 0：全部 1：竞赛 2：练习
      //   pageIndex: 1,
      //   pageSize: 100,
      //   state: 0, // 实训状态  0：全部 1：未开始 2：进行中 3：已结束
      //   name: '',
      //   projectModule: this.type // 1：银行 2：保险 3：证券
      // }).then(res => {
      //   if (res) {
      //     let data = res.items || []
      //     data.forEach(item => {
      //       item.startTime = this.convertLocalTime(item.startTime)
      //       item.endTime = this.convertLocalTime(item.endTime)
      //     })
      //     callback && callback(data)
      //   }
      // })
    },

    // 获取练习列表数据
    getPracticeData () {
      this.getTableData((data) => {
        let arr1 = [], arr2 = []
        data.forEach(item => {
          if (item.classification == 1) {
            arr1.push(item)
          } else {
            arr2.push(item)
          }
        })
        this.practice.tableData1 = arr1
        this.practice.tableData2 = arr2
      })
    },

    // 获取考核列表数据
    getExamData () {
      this.getTableData((data) => {
        let arr1 = [], arr2 = []
        data.forEach(item => {
          if (item.state == 3 || item.state == 4) {
            arr2.push(item)
          } else {
            arr1.push(item)
          }
        })
        this.exam.tableData1 = arr1
        this.exam.tableData2 = arr2
      })
    },

    // 获取记录列表数据
    getRecordData () {
      // this.record.tableData = [{ lastUpdateDate: '2025-06-24 17:52', caseName: '陪练端-银行理财顾问岗位' }]
      // this.record.totalNum = 1
      apiUser.GetCaseRecords({
        mode: this.type = this.type == 1 ? 2 : 1,// 接口中类型标识：1=工作流案例，2=场景类型
        pageIndex: this.record.param.pageIndex,
        pageSize: this.record.param.pageSize
      }
      ).then((res) => {
        console.log(res);
        if (res.data.data.length > 0) {
          this.record.tableData = res.data.data || []
          this.record.totalNum = res.data.totalCount || 0
        } else {
          this.record.tableData = []
          this.record.totalNum = 0
        }
      });
    },

    //删除学生工作流数据
    DeleteWorkflowData () {
      let dygptaccount
      let type = sessionStorage.getItem('casetype')
      if (type == 1) {
        dygptaccount = sessionStorage.getItem('dygptaccount') + '_AL'
      } else if (type == 2) {
        dygptaccount = sessionStorage.getItem('dygptaccount') + '_GZL'
      } else {
        dygptaccount = sessionStorage.getItem('dygptaccount')
      }
      apiUser.DeleteWorkflowData({
        studentUsername: dygptaccount
      }
      ).then((res) => {
        console.log(res);
      });
    },

    // 打开案例
    openCase (item, scenarioName) {
      sessionStorage.removeItem('znty_save_list')
      this.handleCaseStart(item, scenarioName)
    },

    // 开始练习/考核
    handleCaseStart (item, scenarioName) {
      sessionStorage.setItem('relatedId', item.relatedId)
      console.log(item);
      sessionStorage.setItem('caseno', item.id)
      sessionStorage.setItem('casename', item.name)
      sessionStorage.setItem('describtion', item.describtion)
      sessionStorage.setItem('isPrecondition', item.isPrecondition)
      // sessionStorage.setItem('FileName', item.FileName)
      // sessionStorage.setItem('FileUrl', item.FileUrl)
      sessionStorage.setItem('scenarioName', scenarioName)//将类型名称（智能客服、训练智能体、投研报告智能体）存起来
      //进入时，默认一个token,点击返回fastgpt时清空
      sessionStorage.setItem('znkf_key', window.CJTY_AIwenda_token)
      sessionStorage.setItem('xlznt_tw_key', window.CJTY_AItiwen_token)
      sessionStorage.setItem('xlznt_jf_key', window.CJTY_AIjifen_token)

      sessionStorage.setItem('znkf_key_save', '')
      sessionStorage.setItem('xlznt_tw_key_save', '')
      sessionStorage.setItem('xlznt_jf_key_save', '')

      //案例进入，非场景体验进入
      sessionStorage.setItem('isCJTY', 0)
      this.DeleteWorkflowData()
      // if (scenarioName == '商务数据分析智能体') {
      //   this.$router.push({ path: '/case/shangwushuju' })
      // } else if (scenarioName == '贷款额度预测智能体') {
      //   this.$router.push({ path: '/case/xinyongfengxian' })
      // } else if (scenarioName == '金融反欺诈预测') {
      //   this.$router.push({ path: '/case/fanqizha' })
      // } else {
      //   this.$router.push({ path: '/case/casedescription', query: { casepreProcess: item.isPrecondition } })
      // }
      if (scenarioName == '商务数据分析智能体') {
        this.$router.push({ path: '/case/shangwushuju' })
      } else if (scenarioName == '金融风险管理') {
        this.$router.push({ path: '/case/xinyongfengxian' })
      } else if (scenarioName == '金融反欺诈') {
        this.$router.push({ path: '/case/fanqizha' })
      } else {
        this.$router.push({ path: '/case/casedescription', query: { casepreProcess: item.isPrecondition } })
      }
    },

    // 打开解析
    handleAnalysisOpen (row) {
      this.caseAnalysis.dialogVisible = true
      this.caseAnalysis.loading = true
      this.caseAnalysis.loading = false
      this.getCaseAnalysis(row)
    },

    // 获取解析
    getCaseAnalysis (row) {
      apiUser.GetCaseAnalysis(
        {
          // caseId: row.caseId
          Id: row.id
        }
      ).then((res) => {
        console.log("getCaseAnalysis>>>", res);
        let d = res.data
        let newarr = []
        d.forEach(item => {
          item.scoringDetails.forEach(item2 => {
            newarr.push(item2)
          })

        })
        console.log("d>>>", d);

        this.caseAnalysis.tableData = newarr || []
        // this.caseAnalysis.tableData = res.data[0].scoringDetails || []
      });
    },

    // 合并单元格
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.filterData(this.caseAnalysis.tableData).one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    filterData (arr) {
      let spanOneArr = []
      let concatOne = 0
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
        }
        else {
          //注意这里的quarterly是表格绑定的字段，根据自己的需求来改
          if (item.workflowName === arr[index - 1].workflowName) {
            //第一列需合并相同内容的判断条件
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return { one: spanOneArr }
    }
  }
}
</script>

<style lang="less" scoped>
.page-layer {
  padding: 0 50px;
  user-select: none;
  // background-image: url('~@assets/imgs/case/scene/Slice 167.png');
  // background-size: 100% 100%;

  .page-layer_title {
    width: 100%;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-top: 30px;
  }

  .tabs-wrap {
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    .btn {
      display: inline-block;
      height: 36px;
      line-height: 36px;
      margin-right: 20px;
      padding: 0 70px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      position: relative;
      box-sizing: border-box;
      color: #0E1E48;
      // background-color: #eef4fd;
      background-color: #fff;

      letter-spacing: 4px;

      &.active {
        // color: #FFFFFF !important;
        background-color: #dce3ff !important;
        color: #4568F7 !important;
      }
    }

    .backBtn {
      margin-left: auto;
    }
  }

  .exam-wrap {
    margin-top: 30px;

    .mode-view {
      .block {
        margin-bottom: 30px;

        .block-title {
          width: 400px;
          margin-bottom: 20px;
          // height: 34px;
          // line-height: 34px;
          font-size: 32px;
          color: #648DE4;
          font-weight: 600;
          // background: linear-gradient(to right, #235df05e, #1ccaff42, transparent);

          // &::before {
          //   content: "";
          //   display: inline-block;
          //   width: 4px;
          //   height: 100%;
          //   background-color: #0a6cdd;
          //   vertical-align: top;
          //   margin-right: 15px;
          //   border-radius: 5px 0 0 5px;
          // }
        }
      }
    }

    ul {
      height: 100%;
      overflow: auto;
      position: relative;

      &.notData {
        &::before {
          content: "敬请期待";
          display: block;
          text-align: center;
          line-height: 130px;
          color: #b7b7b7;
          font-size: 20px;
        }
      }

      li {
        position: relative;
        // width: 282px;
        // height: 310px;
        width: 364px;
        height: 274px;
        // background-color: #fff;
        background-image: url('~@imgs/case/scene/Slice 166.png');
        float: left;
        box-sizing: border-box;
        margin-bottom: 15px;
        margin-right: 15px;
        border-radius: 10px;
        // border: 2px solid #4568F7;
        // box-shadow: 0 4px 12px rgba(69, 104, 247, 0.15);
        cursor: pointer;
        overflow: hidden;

        &:hover {
          // box-shadow: 0 4px 16px rgba(69, 104, 247, 0.25);
          scale: 1.02;
        }

        &::before {
          content: "";
          display: block;
          width: 100%;
          height: 100%;
          background-size: 50% 50%;
          /* 调整图片大小为50%，让图标更精致 */
          background-repeat: no-repeat;
          background-position: center 30px;
          /* 调整垂直位置，使图标居中偏上 */
          position: absolute;
          // transition: background-size 0.3s ease;
          /* 添加过渡效果，提升交互体验 */
        }

        &:hover::before {
          background-size: 55% 55%;
          /* 鼠标悬停时图标轻微放大 */
        }

        &.icon1::before {
          background-image: url('~@imgs/case/scene/icon1.png');
        }

        &.icon2::before {
          background-image: url('~@imgs/case/scene/icon2.png');
        }

        &.icon3::before {
          background-image: url('~@imgs/case/scene/icon3.png');
        }

        &.icon4::before {
          background-image: url('~@imgs/case/scene/icon4.png');
        }

        &.icon5::before {
          background-image: url('~@imgs/case/scene/icon5.png');
        }

        top: 0;
        left: 0;
      }

      .title-inner {
        display: inline-block;
        // width: 100%;
        width: 260px;
        height: auto;
        padding-left: 40px;
        margin-bottom: 10px;
        line-height: 24px;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        color: #4568F7;
        text-align: center;
        position: absolute;
        bottom: 15px;
        letter-spacing: 1px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .attr-inner {
        display: flex;
        align-items: center;
        margin-top: 10px;
      }

      .state-inner {
        display: inline-block;
        white-space: nowrap;
        margin-right: 10px;
        padding: 0 8px;
        height: 20px;
        line-height: 20px;
        border-radius: 3px;
        font-size: 12px;
        box-shadow: 0 0 0 1px #fff;
      }

      // 未开始
      &.not .state-inner {
        background-color: #ECFEEE;
        color: #45D3B1;
      }

      // 进行中
      &.afoot .state-inner {
        background-color: #ECF1FE;
        color: #516FBB;
      }

      // 已结束
      &.end .state-inner {
        background-color: #ECECEC;
        color: #8B8B8B;
      }

      .timer-inner {
        color: var(--color4);
        font-size: 13px;
        white-space: nowrap;
        margin-left: auto;
        line-height: 1.2;
      }
    }

  }
}

.table-header-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 0;

  span {
    font-size: 15px;
    padding-right: 10px;
  }
}

.zuhelie {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
  padding-right: 15px;

  .zuhelie-left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .zuhelie-name {
      margin-right: 15px;
      width: 150px;
      text-align: left;
      white-space: nowrap;
      /* 防止文本换行 */
      overflow: hidden;
      /* 隐藏超出容器的部分 */
      text-overflow: ellipsis;
      /* 显示省略号 */
    }

    .zuhelie-defen {
      color: #4568F7;
    }
  }

  .zuhelie-right {
    cursor: pointer;
    color: #4568F7;
  }
}

.pagination-wrap {
  margin-top: 10px;
  text-align: right;
}
</style>
<style lang="less" scoped>
.caseAnalysis-dialog {

  /deep/.el-dialog__body {
    //公用
    .block-title {
      margin-bottom: 20px;
      height: 18px;
      line-height: 18px;
      font-size: 16px;
      color: #000;

      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 18px;
        background-color: #2084f6;
        vertical-align: top;
        margin-right: 10px;
      }
    }
  }

}

/**
 * -------------------------------------------------------
 * 滚动条
 * -------------------------------------------------------
 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 10px -2px #ffffff;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*background: #ddd;*/
}
</style>